import React, { PureComponent } from 'react';
import { Menu, MenuItem } from '@blueprintjs/core';
import { FilterLabel, FilterType } from 'utilities/enum-utils';
import CommonUtils from 'utilities/common-utils';
import { timeZone } from 'interfaces/timezone-type';
import { FilterItemMenu } from 'common-components/filter';
import _ from 'lodash';
import { Icon } from 'antd';
import { IFilter } from 'interfaces/filter-interfaces';
import { Box, Button, Text, ScrollAreaAutosize, Divider } from '@good/ui/core';
import { ArrowLeft, ArrowRight } from '@good/icons';

export interface IMoreFilterMenuProps {
  addNewFilterPanel: string;
  filters: IFilter[];
  saveNewFilterValue: (filterType, newFilterValue, selectionLabel) => void;
  removeFilter: (filterType) => void;
  addFilter: (filterType) => void;
  displayTimezone: timeZone;
  availableFilters: Array<FilterType>;
  onClose: () => void;
  onChangeAddNewFilterPanel: (filterType: string | null) => void;
}

interface IMoreFilterMenuState {
  loading: boolean;
}

class MoreFilterMenu extends PureComponent<IMoreFilterMenuProps, IMoreFilterMenuState> {
  private _addFilter = (filterType) => {
    this.props.addFilter(filterType);
  };
  render() {
    const { addNewFilterPanel, filters, displayTimezone } = this.props;

    return (
      <Menu style={{ minWidth: '300px' }} className={'p-none'}>
        {addNewFilterPanel ? (
          <div className={'anim-slide-left'}>
            <Button
              onClick={() => this.props.onChangeAddNewFilterPanel(null)}
              m='xs'
              mb={0}
              variant='default'
              leftSection={<ArrowLeft />}
              size='xs'
            >
              Back
            </Button>
            <FilterItemMenu
              filter={{ filter: addNewFilterPanel, values: [] }}
              saveNewFilterValue={this.props.saveNewFilterValue}
              removeFilter={this.props.removeFilter}
              canRemove={false}
              displayTimezone={displayTimezone}
              onClose={this.props.onClose}
            />
          </div>
        ) : (
          <div>
            <Box p='xs' px='sm'>
              <Text fw={600}>Filter by</Text>
            </Box>
            <Divider />
            {/*Filter option are displayed alphabetically.*/}
            <ScrollAreaAutosize mah={300} className='anim-slide-right'>
              {_.map(
                _.orderBy(
                  _.map(this.props.availableFilters, (availableFilter) => {
                    return { type: availableFilter, label: FilterLabel[availableFilter] };
                  }),
                  'label',
                ),
                (filter, idx) => {
                  return (
                    <MenuItem
                      label={''}
                      className='hover-bg-gray-lightest ph-medium pv-small flex-row justify-between'
                      onClick={() => this._addFilter(filter.type)}
                      text={
                        <div className={'flex-row justify-between align-center'}>
                          {filter.label}
                          <ArrowRight />
                        </div>
                      }
                      shouldDismissPopover={!!CommonUtils.findFilter(filter.type, filters)}
                      key={idx}
                    />
                  );
                },
              )}
            </ScrollAreaAutosize>
            <Divider />
            <Box p='xs' px='sm'>
              <Button variant='outline' onClick={this.props.onClose}>
                Cancel
              </Button>
            </Box>
          </div>
        )}
      </Menu>
    );
  }
}

export default MoreFilterMenu;
